import { axios } from '../config/axios';
import security from './security'

// Configurações > Menu: { menu_color: '#rrggbb' ou '' (cor padrão), updated_at }
const Appearance = {};

Appearance.find = () => {
  return security.validation(axios.get('/appearance'));
};

Appearance.update = (body) => {
  return security.validation(axios.patch('/appearance', body));
};

export default Appearance;
